class AccountSettings.UserProfileAttributesEditorView extends Backbone.View
  template: JST["backbone/templates/account_settings/user_profile_attributes/editor"]
  blank_model: Backbone.Model.extend({})

  events:
    'change #attribute_type_name': '_onChangeType'
    'focusout #name': '_fillCode'

  initialize: (@options = {}) ->
    @isNew = @options.new
    @model = @options.model
    @collection = @options.collection
    @availableTypes = @collection.availableTypes
    @readonlyFields = @collection.readonlyFields
    @modal = @_getModal()
    @modalView = new App.ModalView({instance: @})
    # This is because modals ARE NOT removed when closed, so we have several radio buttons with the same id.
    # That's a problem because our css trick to show a different colour when clicking on a radio button will fail
    @random = Math.floor(Math.random() * 9999999)

  render: ->
    @$el.html @template
      self: @
      availableTypes: @availableTypes
      random: @random
      isNew: @isNew
    @nameField = @$el.find('#name')
    @codeField = @$el.find('#code')
    @adviseForMerge = @$el.find('#advise_for_merge_' + @random)
    @multipleField = @$el.find('#multiple_' + @random)
    @attributeTypeField = @$el.find('#attribute_type_name')
    @_onChangeType()
    @_addTags()
    @_disableButtonsIfNeeded()
    @modalView.firstTab._activate()

  _onChangeType: =>
    @_checkBooleanType()
    @_checkFixedString()

  _checkBooleanType: ->
    $radio = @$el.find('#multiple_radio_button .radio-as-buttons')
    if @attributeTypeField.val() == 'Boolean'
      $radio.find('input')[0].checked = false
      $radio.find('input')[1].checked = true
      $radio.hide()
    else
      $radio.show()

  _checkFixedString: ->
    if @_tagsAreAllowed()
      @$el.find('#tags_container').show()
    else
      @$el.find('#tags_container').hide()

  _fillCode: =>
    if _.isEmpty(@codeField.val().trim())
      @codeField.val(@nameField.val().replace(/[^\w_]/g, '_').toLowerCase())

  _tagsAreAllowed: ->
    @attributeTypeField.val() == 'FixedString'

  exit: =>
    @modalView.destroy()

  save: =>
    if @validate()
      @saveToServer()

  validate: =>
    success = true
    for element in [@nameField, @codeField]
      if _.string.isBlank(element.val())
        element.addClass('error')
        success = false
      else
        element.removeClass('error')
    return success

  activate: =>
    @modalTab._activate()

  saveToServer: ->
    @modalView.disableAll()
    @model.save(@_serialize(), { success: @updateModel })

  updateModel: (model, data) =>
    if data.error
      showError(data.error)
      @modalView.enableAll()
      @_disableButtonsIfNeeded()
      return
    if @isNew
      @collection.add(model)
    else
      model.set(data)
    @exit()

  _addTags: ->
    keywordList = new Monitoring.Collections.SortableKeywordsCollection()
    keywordList.reset(@model.get('tags'));
    @keywordsView = new Monitoring.Views.SortableKeywordView
      keywords: keywordList
      entityName: 'keepcon_settings_account_setting'
      attributeName: 'charts_settings'
      placeholder: 'Add tags'
      keywordId: 'tags-cbo'
    @$el.find('#tags').html(@keywordsView.render().el)

  _disableButtonsIfNeeded: ->
    if !@isNew
      @$el.find("##{id}").prop('disabled', true) for id in @readonlyFields
      @$el.find('#multiple_' + @random).prop('disabled', true)
      @$el.find('#not_multiple_' + @random).prop('disabled', true)

  _serialize: ->
    results = {
      name: @nameField.val()
      code: @codeField.val()
      multiple: @multipleField.is(':checked')
      advise_for_merge: @adviseForMerge.is(':checked')
      attribute_type_name: @attributeTypeField.find('option:selected').val()
      order: if @isNew then @collection.size() else @collection.indexOf(@model)
    }
    if @_tagsAreAllowed()
      results['tags_attributes'] = @keywordsView.getKeywordsAttributes()
    results

  _getModal: ->
    title: I18n.t("monitoring.conversation_attributes.editor.title.#{if @isNew then 'new' else 'edit'}")
    buttons: [
      {
        title: I18n.t('monitoring.conversation_attributes.editor.cancel'),
        event: 'exit'
      },
      {
        title: I18n.t('monitoring.conversation_attributes.editor.save'),
        event: 'save'
      },
    ]
